import React, { Component } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import DocumentHeadTags from 'components/document-head-tags'
import ReferralInviteSendModal from 'components/modals/referral/send'

interface OwnProps {
  navigate: NavigateFunction
}

type Props = OwnProps

class ReferralInviteSend extends Component<Props> {
  _closeModal = () => {
    this.props.navigate('/')
  }
  _onInviteSent = () => {
    this.props.navigate('/referral-invite/thank-you')
  }

  render() {
    return (
      <div className="Referral_Modal">
        <DocumentHeadTags title="Invite users | DISCO" />
        <ReferralInviteSendModal
          onInviteSent={this._onInviteSent}
          onClose={this._closeModal}
        />
      </div>
    )
  }
}

const ReferralInviteSendWithRouter = (props: Omit<Props, 'navigate'>) => {
  const navigate = useNavigate()
  return <ReferralInviteSend {...props} navigate={navigate} />
}

export default ReferralInviteSendWithRouter
